export default __webpack_public_path__ + "static/media/confectionists-master-baker.8a0b244a.svg";